import './tmp.css'

import Button from 'react-bootstrap/esm/Button';
import Container from 'react-bootstrap/esm/Container';

import InformationMassage from '../../../components/InformationMessage';
import TitleBar from '../../../components/TitleBar';
import { consentUrl } from '../../Inquiry/urls';
import { retrieveMe } from '../../../sdk/apis';
import { useEffect, useState } from 'react';
import BottomBar from '../../../components/BottomBar/BottomBar';

const AccountNotice = (
  <>
    <br />
    <div>
      <h4>アカウント申請について</h4>
    </div>
    <div>
      <p>
        はじめての方は「お問い合わせ」より「新規アカウント申請」へお進み下さい。<br />
        申請後、ASEBIシステム管理者より申請書受理のメールを返信致します。1週間ほど待ってもメールが届かない場合、 メールアドレスの入力間違いの可能性がありますので、メールアドレスをご確認の上、再度申請して頂きますようお願い致します。<br />
        <b>※ 申請受付後、承認・アカウント発行までに時間を要しますので、あらかじめご了承下さい。</b>
      </p>
    </div>
  </>
);


const DownloadNotice = (
  <>
    <br />
    <div>
      <h4>実験データのダウンロードについて</h4>
    </div>
    <div>
      <p>
        実験データのダウンロード、実験情報の閲覧はアカウントを取得した方のみご利用できます。
      </p>
    </div>

  </>
);

const downloadData = async () => {
  console.log(process.env)
  const url = `${process.env.PUBLIC_URL}/download/DOI.xlsx`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const blob = await response.blob();
    const urlObject = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = urlObject;
    a.download = url.split('/').at(-1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(urlObject);
  } catch {
    alert('ファイルを保存することができませんでした。');
  }
};

export const tosMain = (
  <>
    <p>
      <div className='sentence'>
        ASEBIで公開するデータとは、実験で取得された数値データ、画像（動画、写真を含む）及びその他の情報並びにこれらに関連する情報（加振条件、計測条件、試験体図面等を含む）です。<br />
        <div className='en'>
          The data available from ASEBI includes experimental measurements, images (including videos and photographs), and other information (including excitation conditions, measurement conditions, test specimen drawings, etc.).
        </div>
      </div>
      <div className='sentence'>
        ASEBIからダウンロード等により提供されるデータを利用する場合は、以下のことを遵守してください。
        <br />
        <div className='en'>
          When using data obtained from ASEBI through downloads or other means, please comply with the following.
        </div>
      </div>
    </p>
    <ol>
      <li>
        <div className='sentence'>
          利用の際の禁止事項について
          <br />
          <div className='en'>
            Prohibited Uses
          </div>
        </div>
      </li>
      <p>
        データの利用は、研究、教育若しくは行政目的（例えば、研究論文の参照資料としての利用、学校その他の教育機関において授業の過程における利用又は行政目的で市民サービスでの利用等）又は私的目的に限ります。いずれの場合においても以下の利用は禁止いたします。<br />
        <div className='en'>
          The usage of data is limited to research, educational, or administrative purposes (e.g., use as reference material for research papers, use in the course of classes at schools and other educational institutions, or use in the civil service for administrative purposes, etc.) or private purposes. In any case, the following usage is prohibited.
        </div>
        <ul style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
          <li>
            <div className='sentence'>
              特定の個人や団体・組織の活動を応援・推奨・誹謗・中傷するための利用
              <br />
              <div className='en'>
                Use for purpose of supporting, promoting, defaming, or slandering specific individuals, groups, or organizations
              </div>
            </div>
          </li>
          <li>
            <div className='sentence'>
              公序良俗に反する目的・態様による利用
              <br />
              <div className='en'>
                Use for purposes or in ways that violate public order and morals
              </div>
            </div>
          </li>
          <li>
            <div className='sentence'>
              防災科研の事業に誤解を与えるような利用
              <br />
              <div className='en'>
                Use that could mislead people regarding the work of NIED
              </div>
            </div>
          </li>
          <li>
            防災科研の組織イメージや信用度を著しく低下させる可能性のある利用、特定の個人や組織の権利を侵害する恐れのある利用
            <br />
            <div className='en'>
              Use that could significantly damage the image or credibility of NIED, or infringe on the rights of specific individuals or organizations
            </div>
          </li>
        </ul>
        <div className='sentence'>
          ASEBI関連情報（学術研究論文を含む）について、あたかも個人の成果と偽ったり、又は同様な誤解を与えるように扱ったりする行為も、これに含まれますのでご注意ください。<br />
          <div className='en'>
            Note that this also includes actions such as falsely presenting ASEBI-related information (including academic research papers) as one’s own achievements, or treating such information in a way that could cause similar misunderstandings.
          </div>
        </div>
        また、私的利用の範囲を超えた商品・サービスの広告、提供、販売など商業利用する場合は、別途手続きが必要ですので防災科研　ASEBI担当に連絡してください（連絡先: asebi［at］bosai.go.jp）。※［at］を小文字の@に置き換えてください。
        <br />
        <div className='en'>
          In addition, for commercial use, such as advertising, offering, or selling products or services beyond the scope of personal use, separate procedures are required. Contact the ASEBI representative at NIED (email: asebi[AT]bosai.go.jp). * Replace [AT] with @
        </div>
      </p>
      <li>
        <div className='sentence'>
          責任の無保証
          <br />
          <div className='en'>
            Disclaimer of Liability
          </div>
        </div>
      </li>
      <p>
        <div className='sentence'>
          ASEBIで公開しているデータは、実験で得られた素データであり、データの信頼性について一切保証するものではなく、またASEBIの情報を利用することによって生じる、利用者が被るいかなる損害についても防災科研が責任を負うものではありません。
          <br />
          <div className='en'>
            The data available in ASEBI contains raw data obtained from experiments, and its reliability is not guaranteed. NIED is not responsible for any damage incurred by users as a result of using ASEBI information.
          </div>
        </div>
        ユーザー登録をご申請いただいた時点で、この免責事項を承諾したものとみなします。
        <br />
        <div className='en'>
          In applying for user registration, you are deemed to have accepted this disclaimer.
        </div>
      </p>
      <li>
        <div className='sentence'>
          利用上の注意
          <br />
          <div className='en'>
            Precautions for Use
          </div>
        </div>
      </li>
      <p>
        ASEBIから提供されたデータを利用して論稿等を発表する場合には、出典元<a href='#' onClick={downloadData}>（各実験データの名称および識別子（DOI）一覧）</a>が分かるように以下のような記載をしてください。
        <div className='en'>
          When publishing papers using data provided by ASEBI, please cite the source as follows so that the source can be identified <a href='#' onClick={downloadData}>(List of names and identifiers (DOIs) for each experimental data)</a>.
        </div>
        <ul style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
          <li>
            <div className='sentence'>
              参考文献の項目がある場合、実験データの課題名称および識別子（DOI）を引用すること。
              <br />
              （例）国立研究開発法人防災科学技術研究所「E-Defense実験データアーカイブ（ASEBI）」，課題名「＊＊＊」，https://doi.org/10.17598/nied.0020-（実験番号）○○○○
              <br />
              <div className='en'>
                For citation as a reference: Cite the name and identifier (DOI) of the experimental data; i.e. National Research Institute for Earth Science and Disaster Resilience, “E-Defense Experimental Data Archive (ASEBI),” Project Name “***,” https://doi.org/10.17598/nied.0020⁻(Experiment #)○○○○
              </div>
            </div>
          </li>
          <li>
            参考文献の項目が無い場合、文末または謝辞に出典がわかる文章を載せること。
            <br />
            （例）本報告では、国立研究開発法人防災科学技術研究所「E-Defense実験データアーカイブ（ASEBI）」より課題名「＊＊＊」の実験データ（https://doi.org/10.17598/nied.0020-（実験番号）○○○○）を使用した。
            <br />
            <div className='en'>
              For in-text or acknowledgment citations: Include a statement indicating the data source at the end of the text or in the acknowledgments section; i.e. In this report, experimental data from the National Research Institute for Earth Science and Disaster Resilience “E-Defense Experimental Data Archive (ASEBI)” with the project name “***” (https://doi.org/10.17598/nied.0020-(Experiment #)○○○○) was used.
            </div>
          </li>
        </ul>
        発行された時点で、その旨防災科研に連絡してください（連絡先: asebi［at］bosai.go.jp）。※［at］を小文字の@に置き換えてください。なお、上記発表した場合は、別刷・コピー等を一部提供ください。
        <br />
        <div className='en'>
          Please notify the ASEBI representative when the paper is published (contact: asebi[at]bosai.go.jp). *Replace [at] with @. In addition, please provide a copy or separate printout of the above publication.
        </div>
      </p>
      <li>
        <div className='sentence'>
          取得後のデータの取り扱い
          <br />
          <div className='en'>
            Handling of Data Obtained from ASEBI
          </div>
        </div>
      </li>
      <p>
        取得後のデータの第三者への開示、譲渡、提供、再配信は禁止しております。
        <div className='en'>
          Disclosure, transfer, provision, or redistribution of the obtained data to third parties is prohibited.
        </div>
        なお、論文に引用する際は、発表した論文から、元データが複製できないような措置を講じてください。
        <br />
        <div className='en'>
          When citing data in publications, please take appropriate measures to prevent the original data from being reproduced from the published paper.
        </div>
        また、映像データを公衆の場等で使用する場合（社内研修なども含みます）は、別途手続きが必要ですので防災科研ASEBI担当に連絡してください（連絡先: asebi［at］bosai.go.jp）。※［at］を小文字の@に置き換えてください。
        <br />
        <div className='en'>
          In addition, if image data is to be used in public places (including internal training), please contact the ASEBI representative at NIED, as separate procedures are required. (contact: asebi[at]bosai.go.jp). *Replace [at] with @.
        </div>
      </p>
      <li>
        <div className='sentence'>
          データの内容及び利用条件等の変更について
          <br />
          <div className='en'>
            Changes to Data Contents and Terms of Use
          </div>
        </div>
      </li>
      <p>
        <div className='sentence'>
          ASEBIデータの内容や公開方式は、変更されることがあります。
          <br />
          <div className='en'>
            The content and publication method of ASEBI data are subject to change.
          </div>
        </div>
        データ公開のポリシーや利用条件等が変更されることもあります。最新の更新状況について逐次ご確認ください。最新の利用条件にアクセスした段階で、条件に同意いただけたものとみなします。
        <div className='en'>
          The data disclosure policy and terms of use are also subject to change. Please check for updates on a regular basis. By accessing the latest terms of use, users are deemed to have agreed to them.
        </div>
      </p>
    </ol>
  </>
);


export const hopiMain = (
  <ol>
    <li>
      <div className='sentence'>
        防災科研が収集した個人情報は次の目的で利用します。
        <br />
        <div className='en'>
          Personal information collected by the NIED for user registration will be used for the following purposes:
        </div>
      </div>
    </li>
    <p>
      <div className='sentence'>
        &#9312; ASEBI利用に関する申請者本人への連絡、防災科研の各種イベントや資料の案内・提供、アンケート調査のお願いなどの各種連絡
        <br />
        <div className='en'>
          To contact applicants regarding ASEBI usage, provide information and materials on various events and materials of NIED, request participation in surveys, etc.
        </div>
      </div>
      <div className='sentence'>
        &#9313; ASEBI利用に関する状況の確認、分析、サービス改善
        <br />
        <div className='en'>
          To review, analyze, and improve services related to ASEBI usage.
        </div>
      </div>
      なお、統計的に処理し個人の識別ができないようにした情報は、防災科研の研究開発成果発表会等を通じて第三者に提供することがあります。
      <br />
      <div className='en'>
        Statistically processed information that cannot identify individuals may be provided to third parties through NIED’s research and development presentations.
      </div>
    </p>
    <li>（利用条件に基づき）防災科研に提出された利用成果は、申請者の同意を得たものについて、第三者に提供することがあります。
      <div className='en'>
        Results of usage submitted to NIED under the terms and conditions of use may be provided to third parties with the consent of the applicant.
      </div>
    </li>
    <p></p>
    <li>防災科研が収集した情報について、上記以外の取り扱いをする場合には事前に申請者の同意を得ることとします。
      <div className='en'>
        If information collected by NIED is to be handled in a manner not described above, prior consent will be obtained from the applicant.
      </div>
    </li>
    <p></p>
    <li>
      <div className='sentence'>
        防災科研以外の第三者への提供は、以下の場合を除き、一切行いません。
        <div className='en'>
          Information will not be provided to any third party other than NIED, except in the following cases.
        </div>
      </div>
      <div className='sentence'>
        &#9312; 法令に基づく場合
        <br />
        <div className='en'>
          When required by laws and regulations
        </div>
      </div>
      <div className='sentence'>
        &#9313; 第三者への開示について申請者から承諾を得ている場合
        <br />
        <div className='en'>
          When the applicant has given consent for disclosure to a third party
        </div>
      </div>
      <div className='sentence'>
        &#9314; 防災科研との間で守秘義務契約を締結している業者等に委託する際に、利用目的の範囲内で、当該業務の履行に必要な範囲において提供する場合<br />
        <div className='en'>
          When the information is provided to contractors who have concluded confidentiality agreements with NIED, within the scope of the intended purpose and only to the extent necessary to perform the relevant services
        </div>
      </div>
    </li>
    お問い合わせ先：防災科学技術研究所　兵庫耐震工学研究センター　ASEBI担当　（asebi［AT］bosai.go.jp）
    <br />
    <div className='en'>
      Contact Information: ASEBI Representative, Hyogo Earthquake Engineering Research Center, National Research Institute for Earth Science and Disaster Resilience (asebi[AT]bosai.go.jp). * Replace [AT] with @
    </div>
  </ol>
);


const Home = () => {
  const [createAccountButton, setCreateAccountButton] = useState(<></>);
  useEffect(() => {
    retrieveMe().then(() => {
      setCreateAccountButton(<></>)
    }).catch(() => {
      setCreateAccountButton(
        <div className='button'>
          <Button variant='success' onClick={() => { window.location.href = consentUrl('account') }}>
            新規アカウント申請はこちら
            <br />
            Application for a New Account
          </Button>
        </div>
      )
    });
  }, []);

  const termsOfService = (
    <>
      <div className="container" style={{ paddingTop: '1em' }}>
        <div className='border'>
          <div className="col bg-info bg-opacity-10 rounded"><div style={{ paddingTop: '0.6em', paddingBottom: '0.4em', paddingLeft: '1.5em' }}>
            <h5><b>Ｅ－ディフェンス実験データアーカイブ (ASEBI)の利用条件</b></h5>
            <h6><div className='en'>Terms of Use for Archives of Shakingtable Experimentation dataBase and Information (ASEBI)</div></h6>
          </div></div>
          <div className="col bg-info bg-opacity-10 rounded box">
            <div className='text' style={{ marginTop: 0 }}>
              {tosMain}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  const headingOfPersonalInformation = (
    <>
      <div className="container" style={{ paddingTop: '1em', }}>
        <div className="border">
          <div className="col bg-info bg-opacity-10 rounded"><div style={{ paddingTop: '0.6em', paddingBottom: '0.4em', paddingLeft: '1.5em' }}>
            <h5><b>個人情報取扱について</b></h5>
            <h6><div className='en'>Privacy Policy</div></h6>
          </div></div>
          <div className="col bg-info bg-opacity-10 rounded box">
            <div className="text" style={{ marginTop: 0 }}>
              {hopiMain}
            </div>
          </div>
        </div>
      </div>


    </>
  );

  const systemRequirements = (
    <>
      <div className="container" style={{ paddingTop: '1em', }}>
        <div className="border">
          <div className="col bg-info bg-opacity-10 rounded"><div style={{ paddingTop: '0.6em', paddingBottom: '0.4em', paddingLeft: '1.5em' }}><h5><b>動作環境</b></h5></div></div>
          <div className="bg-info bg-opacity-10 rounded">
            {/* <b>動作環境</b>
          <br /> */}
            <div className='text' style={{ marginTop: 0, marginBottom: 0, paddingBottom: '0.5em' }}>
              OS: Windows10<br />
              ブラウザ: Google ChromeまたはMicrosoft Edgeをご利用ください。<br />
              (上記環境で2022年12月20日動作確認済み)<br />
              また、JavaScript、Cookieが使用できる状態でご利用ください。<br />
              <br />
              ※ブラウザは、最新バージョンでご利用ください。<br />
              ※推奨環境下のご利用でも、OSとブラウザの組み合わせ、ブラウザの設定状況によっては表示、機能に不具合が起こる可能性がございます。<br />　予めご了承ください。<br />
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <TitleBar />
      <Container>
        {/* <div className='container'> */}
        {/* <span> */}
        <h2 style={{ textAlign: 'center', marginTop: '4vh' }}>
          E-Defense実験データアーカイブ (ASEBI)へようこそ
        </h2>
        <h4 style={{ textAlign: 'center' }}>
          Welcome to the Archives of Shakingtable Experimentation dataBase and Information (ASEBI).
        </h4>
        <p>
          Ｅ－ディフェンス 実験データアーカイブ（ASEBI）では、研究者や技術者・防災関係者など専門家は勿論のこと、一般の方々も含めた公共目的のために、Ｅ－ディフェンスを用いた実験で得られたデータを公開しています。実験データのダウンロード、実験情報の閲覧はアカウントを取得した方のみご利用できます。
          <br />
          ASEBIから提供されたデータを利用して論稿等を発表する場合、「Ｅ－ディフェンス実験データアーカイブ（ASEBI）の利用条件」の「３．利用上の注意」をご確認の上、出典元が分かるようにしてください。また、論文が発行された時点で、その旨防災科研にご連絡をお願いいたします。
          <br />
          <div className='en'>
            In this archive, data obtained from E-Defense experiments are available for public purposes, not only for researchers, engineers, disaster prevention specialists, and other professionals, but also for the public. Abstract and representative footage of each experiment are summarized here. Downloading of experimental data and viewing of experimental information is available only to those who have obtained an account.
            <br />
            When publishing a paper using data provided by ASEBI, please clearly cite the source in accordance with the “Precautions for Use” section of the Terms of Use, and notify the ASEBI representative upon publication.
          </div>
        </p>
        {/* </span> */}
        {createAccountButton}
        {/* <div className={styles.border-bottom}></div> */}
        <InformationMassage />
        {/* <Stack gap="2"> */}
        <h3 className="col text-black" style={{ paddingLeft: '3em', paddingTop: '1.5em' }}>利用について</h3>
        {termsOfService}
        {/* <h3 className="col text-black" style={{ paddingLeft: '3em', paddingTop: '1em' }}>個人情報取扱について</h3> */}
        {headingOfPersonalInformation}
        {/* <h3 className="col text-black" style={{ paddingLeft: '3em', paddingTop: '1em' }}>動作環境</h3> */}
        {systemRequirements}
        {/* </Stack> */}
        {/* {AccountNotice}
        {DownloadNotice} */}
        {/* </div> */}
      </Container>
      <BottomBar />
    </>
  );
};

export default Home;
